import { render } from "./ReleaseCard.vue?vue&type=template&id=2d282da8&scoped=true&ts=true"
import script from "./ReleaseCard.vue?vue&type=script&lang=ts"
export * from "./ReleaseCard.vue?vue&type=script&lang=ts"

import "./ReleaseCard.vue?vue&type=style&index=0&id=2d282da8&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d282da8"]])

export default __exports__